import React from 'react';
import { SOCIAL_LINK_ITEMS } from '../config/socialLinks';

function XIcon(props) {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" {...props}>
      <path d="M4 4L20 20" />
      <path d="M20 4L4 20" />
    </svg>
  );
}

function InstagramIcon(props) {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" {...props}>
      <rect x="3.5" y="3.5" width="17" height="17" rx="4.5" />
      <circle cx="12" cy="12" r="4" />
      <circle cx="17.5" cy="6.5" r="0.75" fill="currentColor" stroke="none" />
    </svg>
  );
}

function TikTokIcon(props) {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" {...props}>
      <path d="M14 4v9.25a4.25 4.25 0 1 1-4.25-4.25" />
      <path d="M14 4c.6 1.8 2.15 3.25 4 3.75" />
    </svg>
  );
}

function FacebookIcon(props) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" {...props}>
      <path d="M13.5 21v-7h2.4l.4-3h-2.8V9.2c0-.9.3-1.5 1.5-1.5H16V5.1c-.2 0-.9-.1-1.8-.1-2.6 0-4.2 1.6-4.2 4.5V11H8v3h2.2v7h3.3Z" />
    </svg>
  );
}

const SOCIAL_ICON_MAP = {
  x: XIcon,
  instagram: InstagramIcon,
  tiktok: TikTokIcon,
  facebook: FacebookIcon,
};

function PublicSocialLinks() {
  return (
    <div className="text-center">
      <p className="text-xs font-semibold uppercase tracking-[0.3em] text-stone-500">
        Follow Zaphar
      </p>
      <div className="mt-4 flex flex-wrap items-center justify-center gap-3">
        {SOCIAL_LINK_ITEMS.map((item) => {
          const Icon = SOCIAL_ICON_MAP[item.key];

          return (
            <a
              key={item.key}
              href={item.href}
              target="_blank"
              rel="noreferrer"
              aria-label={item.label}
              title={item.label}
              className="inline-flex h-12 w-12 items-center justify-center rounded-full border border-white/18 bg-white/[0.03] text-stone-200 transition hover:border-amber-300/40 hover:bg-amber-300/10 hover:text-amber-100"
            >
              {Icon ? <Icon className="h-[18px] w-[18px]" /> : <span className="text-sm font-semibold">{item.label.slice(0, 1)}</span>}
              <span className="sr-only">{item.label}</span>
            </a>
          );
        })}
      </div>
    </div>
  );
}

export default PublicSocialLinks;
